import { Input, Table } from 'antd';
import React from 'react';
import BaseLayoutComponent from '../../components/Layout/Admin/BaseLayoutComponent';

function AdminBrandListPage () {
  const dataSource = [
    {
      key: '1',
      brandName: 'Mike',
      brandId: 32,
      companyName: 'slala',
      companyId: 'abc@example.com',
    },
    {
      key: '2',
      brandName: 'John',
      brandId: 42,
      companyName: 'slala',
      companyId: 'abc@example.com',
    },
    {
      key: '3',
      brandName: 'Mike',
      brandId: 32,
      companyName: 'slala',
      companyId: 'abc@example.com',
    },
    {
      key: '4',
      brandName: 'John',
      brandId: 42,
      companyName: 'slala',
      companyId: 'abc@example.com',
    },
    {
      key: '1',
      brandName: 'Mike',
      brandId: 32,
      companyName: 'slala',
      companyId: 'abc@example.com',
    },
    {
      key: '2',
      brandName: 'John',
      brandId: 42,
      companyName: 'slala',
      companyId: 'abc@example.com',
    },
    {
      key: '3',
      brandName: 'Mike',
      brandId: 32,
      companyName: 'slala',
      companyId: 'abc@example.com',
    },
    {
      key: '4',
      brandName: 'John',
      brandId: 42,
      companyName: 'slala',
      companyId: 'abc@example.com',
    },
    {
      key: '1',
      brandName: 'Mike',
      brandId: 32,
      companyName: 'slala',
      companyId: 'abc@example.com',
    },
    {
      key: '2',
      brandName: 'John',
      brandId: 42,
      companyName: 'slala',
      companyId: 'abc@example.com',
    },
    {
      key: '3',
      brandName: 'Mike',
      brandId: 32,
      companyName: 'slala',
      companyId: 'abc@example.com',
    },
    {
      key: '4',
      brandName: 'John',
      brandId: 42,
      companyName: 'slala',
      companyId: 'abc@example.com',
    },
    {
      key: '1',
      brandName: 'Mike',
      brandId: 32,
      companyName: 'slala',
      companyId: 'abc@example.com',
    },
    {
      key: '2',
      brandName: 'John',
      brandId: 42,
      companyName: 'slala',
      companyId: 'abc@example.com',
    },
    {
      key: '3',
      brandName: 'Mike',
      brandId: 32,
      companyName: 'slala',
      companyId: 'abc@example.com',
    },
    {
      key: '4',
      brandName: 'John',
      brandId: 42,
      companyName: 'slala',
      companyId: 'abc@example.com',
    },
    {
      key: '1',
      brandName: 'Mike',
      brandId: 32,
      companyName: 'slala',
      companyId: 'abc@example.com',
    },
    {
      key: '2',
      brandName: 'John',
      brandId: 42,
      companyName: 'slala',
      companyId: 'abc@example.com',
    },
    {
      key: '3',
      brandName: 'Mike',
      brandId: 32,
      companyName: 'slala',
      companyId: 'abc@example.com',
    },
    {
      key: '4',
      brandName: 'John',
      brandId: 42,
      companyName: 'slala',
      companyId: 'abc@example.com',
    },
    {
      key: '1',
      brandName: 'Mike',
      brandId: 32,
      companyName: 'slala',
      companyId: 'abc@example.com',
    },
    {
      key: '2',
      brandName: 'John',
      brandId: 42,
      companyName: 'slala',
      companyId: 'abc@example.com',
    },
    {
      key: '3',
      brandName: 'Mike',
      brandId: 32,
      companyName: 'slala',
      companyId: 'abc@example.com',
    },
    {
      key: '4',
      brandName: 'John',
      brandId: 42,
      companyName: 'slala',
      companyId: 'abc@example.com',
    },
    {
      key: '1',
      brandName: 'Mike',
      brandId: 32,
      companyName: 'slala',
      companyId: 'abc@example.com',
    },
    {
      key: '2',
      brandName: 'John',
      brandId: 42,
      companyName: 'slala',
      companyId: 'abc@example.com',
    },
    {
      key: '3',
      brandName: 'Mike',
      brandId: 32,
      companyName: 'slala',
      companyId: 'abc@example.com',
    },
    {
      key: '4',
      brandName: 'John',
      brandId: 42,
      companyName: 'slala',
      companyId: 'abc@example.com',
    },
  ];

  const columns = [
    {
      title: 'Brand Name',
      dataIndex: 'brandName',
      key: 'brandName',
    },
    {
      title: 'Brand Id',
      dataIndex: 'brandId',
      key: 'brandId',
    },
    {
      title: 'Company Name',
      dataIndex: 'companyName',
      key: 'companyName',
    },
    {
      title: 'Company Id',
      dataIndex: 'companyId',
      key: 'companyId',
    },
  ];
  return (
    <BaseLayoutComponent>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div className="col-md-4"
          style={{ margin: 'auto' }}>
          {/* <div className="common_search">
            <Input placeholder="Search Campaign" allowClear size="large" prefix={<AiOutlineSearch/>} onChange={onSearchCampaign}/>
        </div> */}
          <Input.Search onChange={()=>{}}
            value={''}
            className="common_input"
            placeholder="Search Brand or Company"
            enterButton
            onSearch={()=>{}}/>

        </div>
        <Table dataSource={dataSource}
          columns={columns} />
      </div>
    </BaseLayoutComponent>
  );
}

export default AdminBrandListPage;
